export const findSubListTopPosition = (arrayLength, parentIndex, rowAmount) => {
    const rowHeight = window.matchMedia("(min-width: 813px)").matches ? 33 : 23;
    const parentBorderHeight = window.matchMedia("(min-width: 900px)").matches ? 2 : 1;
    const lengthDifference = parentIndex === rowAmount - 1 ? rowAmount - parentIndex : parentIndex + arrayLength - rowAmount;
    let topPosition = '';
    if (arrayLength >= rowAmount) {
      topPosition = `-${rowHeight * parentIndex + parentBorderHeight}px`;
    } else if (arrayLength + parentIndex <= rowAmount) {
      topPosition = `-${parentBorderHeight}px`;
    } else {
      topPosition = `-${rowHeight * lengthDifference + parentBorderHeight}px`;
    }
    return topPosition;
  }
  
export const findSubItemClassName = (subItemIndex, index, arrayLength, itemLineNumber, parentIndex, rowAmount) => {
    const lengthDifference = rowAmount - arrayLength;
    let itemClassName = '';
    subItemIndex === index ? (itemClassName += 'Sub-item Sub-item-active') : (itemClassName += 'Sub-item');
    itemLineNumber === rowAmount ? itemClassName += ' Sub-item-bottom-border' : itemClassName += '';
          if (arrayLength >= rowAmount) {
            if (itemLineNumber === parentIndex) {
              itemClassName += ' Sub-item-no-left-border';
            }
            if(itemLineNumber === rowAmount - 1) {
              itemClassName += ' Sub-item-bottom-border';
            }
          } else {
            if (arrayLength + parentIndex < rowAmount) {
              index === 0 ? itemClassName += ' Sub-item-no-left-border' : itemClassName += '';
            }
            if (itemLineNumber + lengthDifference === parentIndex) {
              itemClassName += ' Sub-item-no-left-border';
            }
            if (index === arrayLength - 1) {
              itemClassName += ' Sub-item-bottom-border';
            }
          }
  
      return itemClassName;
}

export const findSelectionClassName = (index, arrayLength, selectionIndex, optionIndex) => {
  let className = 'Options-list';
  if (index === arrayLength - 1) { className += ' Not-active'; }
  if (index === 0) { className += ' Option-list-main' };
  if (index === selectionIndex) { className += ' Highlighted'; }
  if (optionIndex !== null && selectionIndex === 0) {
    if (index === selectionIndex) { 
      className += ' Option-list-active';
    } else { className += ' disabled'; }
  } else if (optionIndex !== null) {
    if (index === selectionIndex) { className += ' Option-list-active'; }
  }
  return className;
};

export const convertPlusMinus = (str) => {
  const newString = typeof str === 'string' ? str.replace("+-" , "\xB1") : str;
  return newString;
}

export const convertToIconName = (str) => {
  return str[0].toLowerCase() + str.slice(1).replace(/[" "]/g, "");
}
